import { departmentNameConstants,editDepartmentUsersConstans } from '../Constants';
import { adminUsersServices } from '../Services';

export const departmentUsersActions = {
    searchDepartment,
    EDITDepartment
};

function searchDepartment(data: any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: departmentNameConstants.SEARCH_DEPARTMENT_REQUEST,
            data: null
        }));
        adminUsersServices.searchDepartment(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: departmentNameConstants.SEARCH_DEPARTMENT_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: departmentNameConstants.SEARCH_DEPARTMENT_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: departmentNameConstants.SEARCH_DEPARTMENT_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function EDITDepartment(data:any) {
    return (dispatch:any) => {
        dispatch(dispatchFunction({
            type: editDepartmentUsersConstans.EDIT_DEPARTMENT_REQUEST,
            data: null
        }));
        adminUsersServices.editDepartment(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editDepartmentUsersConstans.EDIT_DEPARTMENT_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editDepartmentUsersConstans.EDIT_DEPARTMENT_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editDepartmentUsersConstans.EDIT_DEPARTMENT_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}
function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}